import { util } from 'echarts/core';
import type { DvMarkerOption } from '../../../core/option';
import { type ThemeParser } from '../../../core/theme';
import {
  defaultAnimaionOption,
  defaultItemStyleMap,
  defaultOption
} from '../../../model/series/dvMarkerSeries/defaultOption';
import { normalizeToArray } from '../../../util/utils';

/**
 * 合并固定的默认的配置项 dvMarker type
 * @default  {
 *       dvMarkerType: 'flag',
 *       type: 'custom'
 * }
 * @param dvMarkerSeries 用户的配置项
 */
function parseDvMarkerDefault(dvMarkerSeries: DvMarkerOption[]) {
  dvMarkerSeries.forEach(item => {
    util.merge(item, defaultOption);
  });
}

/**
 * 合并标记系列的全局默认样式
 * @todo 混合标记场景中，全局样式已经没有意义，应当不做处理，需要做判断
 * @param series
 */
function parseItemStyle(series: DvMarkerOption[]) {
  series.forEach((item, index) => {
    const { dvMarkType } = item;
    const defaultItemStyle = defaultItemStyleMap[dvMarkType];
    item.dvItemStyle = util.merge(item.dvItemStyle || {}, defaultItemStyle);
    item.dvAnimationConfig = util.merge(item.dvAnimationConfig || {}, defaultAnimaionOption);
  });
}

export function dvMarkerThemeParse(...args: Parameters<ThemeParser>): ReturnType<ThemeParser> {
  const option = args[0];
  if (typeof option?.series === 'undefined') {
    return;
  }
  const series = normalizeToArray(option.series);
  const dvMarkerSeries = series.filter(
    item => item.type === 'dvMarker'
  ) as unknown as DvMarkerOption[];
  if (dvMarkerSeries.length === 0) {
    return;
  }
  parseDvMarkerDefault(dvMarkerSeries);
  parseItemStyle(dvMarkerSeries);
}
